import { type FC } from "react";

import { Card, CardRowSimple, LoadingSpinner } from "widgets";

import { capitalizeFirstLetter } from "../../../app-utils/string.js";
import { type ServerStatusInfo } from "../../../graphql.js";
import { type ISystemAdminState } from "../../../redux/modules/system-admin.js";

export interface ISystemInformationCardProps {
  systemInfo: ISystemAdminState;
  systemId?: string;
}

const SystemInformationCard: FC<ISystemInformationCardProps> = (props) => {
  const systemDetails: ServerStatusInfo = props.systemInfo.systemDetails;
  const spinner = <LoadingSpinner />;
  const sysId = capitalizeFirstLetter(props.systemId);
  const info = systemDetails ? (
    <>
      <CardRowSimple key={"runtime"} label={"Runtime"} value={systemDetails.runtime} />
      <CardRowSimple key={"os"} label={"Operating system"} value={systemDetails.os} />
      <CardRowSimple key={"version"} label={"Version"} value={systemDetails.version} />
      <CardRowSimple key={"build"} label={"Build"} value={systemDetails.build} />
      <CardRowSimple key={"remote"} label={"Remote"} value={systemDetails.remote} />
      <CardRowSimple key={"jre"} label={"JRE"} value={systemDetails.jre} />
    </>
  ) : (
    <div style={{ textAlign: "center" }}>
      <strong>{`${sysId} Server not running`}</strong>
    </div>
  );

  return (
    <Card
      title={"Server Info"}
      // actionComponents={serverInfoActionComponents}
    >
      {props.systemInfo.isLoadingSystemDetails ? spinner : info}
    </Card>
  );
};

export default SystemInformationCard;
export { SystemInformationCard };
